import { useTranslation } from "@opendash/i18n";
import { Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { TicketManagerConfig, useTicketManager } from "../../..";

type Props = {
  config?: TicketManagerConfig;
};

export const AllTickets = observer((props: Props) => {
  const t = useTranslation();
  const ticketManager = useTicketManager(props.config);

  useEffect(() => {
    ticketManager.fetchTickets();
  }, []);

  return (
    //@ts-ignore
    <Card variant="outlined" style={{ width: "100%" }}>
      <Statistic
        title={t("maintenance:ticket.statistic.total")}
        value={ticketManager.totalCount}
      />
    </Card>
  );
});
